// extracted by mini-css-extract-plugin
export default {"mask":"News_mask__4vMm4"};